<template>
  <div>
    <Table :columns="columns" :data="resources" size="small">
      <template slot-scope="{ row }" slot="dayFrom">
        <select
          v-model="row.day_id_from"
          class="form-control"
          disabled
          v-show="row.day_id_from"
        >
          <option
            v-for="(weekDay, index) in weekDays"
            :key="index"
            :value="weekDay.value"
            >{{ weekDay.text }}
          </option>
        </select>
      </template>
      <template slot-scope="{ row }" slot="dayTo">
        <select
          v-model="row.day_id_to"
          class="form-control"
          disabled
          v-show="row.day_id_to"
        >
          <option
            v-for="(weekDay, index) in weekDays"
            :key="index"
            :value="weekDay.value"
            >{{ weekDay.text }}
          </option>
        </select>
      </template>
      <template slot-scope="{ row }" slot="total_hour">
        <input
          :value="
            calculateTime(
              row.first_in,
              row.first_out,
              row.second_in,
              row.second_out
            ).description
          "
          class="form-control form-control-plaintext"
        />
      </template>
    </Table>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { orderBy } from 'lodash'

// iview
//import 'view-design/dist/styles/iview.css'
import Vue from 'vue'
import ViewUI from 'view-design'
import locale from 'view-design/dist/locale/en-US'
Vue.use(ViewUI, { locale })
Vue.use(ViewUI)

export default {
  props: {
    row: Object
  },
  i18n: {
    messages: {
      en: {
        dayOfWeek: {
          Monday: 'Monday',
          Tuesday: 'Tuesday',
          Wednesday: 'Wednesday',
          Thursday: 'Thursday',
          Friday: 'Friday',
          Saturday: 'Saturday',
          Sunday: 'Sunday'
        }
      },
      kh: {
        dayOfWeek: {
          Monday: 'ច័ន្ទ',
          Tuesday: 'អង្គារ',
          Wednesday: 'ពុធ',
          Thursday: 'ព្រហស្បតិ៌',
          Friday: 'សុក្រ',
          Saturday: 'សៅរ៌',
          Sunday: 'អាទិត្យ'
        }
      }
    }
  },
  computed: {
    ...mapGetters('humanResource/shiftManagement', ['calculateTime']),
    resources () {
      return orderBy(this.row.details, ['day_id_from'])
    },
    weekDays () {
      return [
        { text: this.$t('dayOfWeek.Monday'), value: 1 },
        { text: this.$t('dayOfWeek.Tuesday'), value: 2 },
        { text: this.$t('dayOfWeek.Wednesday'), value: 3 },
        { text: this.$t('dayOfWeek.Thursday'), value: 4 },
        { text: this.$t('dayOfWeek.Friday'), value: 5 },
        { text: this.$t('dayOfWeek.Saturday'), value: 6 },
        { text: this.$t('dayOfWeek.Sunday'), value: 7 }
      ]
    },
    columns () {
      return [
        {
          title: this.$t('shiftManagement.keyword'),
          key: 'keyword'
        },
        {
          title: this.$t('shiftManagement.fromDay'),
          slot: 'dayFrom'
        },
        {
          title: this.$t('shiftManagement.toDay'),
          slot: 'dayTo'
        },
        {
          title: this.$t('shiftManagement.firstIn'),
          key: 'first_in',
          align: 'center'
        },
        {
          title: this.$t('shiftManagement.firstOut'),
          align: 'center',
          key: 'first_out'
        },
        {
          title: this.$t('shiftManagement.secondIn'),
          align: 'center',
          key: 'second_in'
        },
        {
          title: this.$t('shiftManagement.secondOut'),
          align: 'center',
          key: 'second_out'
        },
        {
          title: this.$t('shiftManagement.totalHous'),
          align: 'center',
          slot: 'total_hour'
        }
      ]
    }
  }
}
</script>
